import React, { useEffect, useState, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';
import { useTranslation } from 'react-i18next';
import update from 'immutability-helper';
import { v4 as uuidv4 } from 'uuid';
import { useCustomModuleState } from '../../Context/index';
import AddEditColumnModal from './AddEditColumnModal';
import ConfirmationPopup from '../../../../../Components/ModalPopup/ConfirmationPopup';
import ColumnDragTR from './ColumnDragTR';
import ImportModal from '../../../BomLibrary/ImportModal';
import { treadFile } from '../../../../../Components/helper';
import { toasterMsg } from '../../../../../Components/Toaster/Toaster';
import { CloseIcon, TickIcon, UploadIcon } from '../../../../../bombiix-icon';
import { NewInput } from '../../../../../Components/PIM/common/NewInput';

function TableCoumnModal({ show, handleClose, tableColumns, handleAddColumnInSection, i, updateTableColumns, labelInModal, handleTableTitle }) {
  const { customModuleState, setCustomModuleState } = useCustomModuleState();
  const { tableControls } = customModuleState;
  const { t } = useTranslation('common');
  const docRef = useRef(null);
  const [state, setState] = useState({
    addEditColumnModal: false,
    editMode: false,
    editedIndex: -1,
    showConfirmModal: false,
    deletedIndex: -1,
  });
  const { addEditColumnModal, editMode, editedIndex, showConfirmModal, deletedIndex } = state;

  const contextTableColumn = tableColumns;
  const [showUploadModal, setShowUploadModal] = useState(false);

  const maxColLimit = 10;
  const handleColumn = () => {
    setState((prevState) => ({
      ...prevState,
      addEditColumnModal: true,
    }));
  };
  const handleCloseColumn = () => {
    setState((prevState) => ({
      ...prevState,
      addEditColumnModal: false,
      editMode: false,
      editedIndex: -1,
    }));
  };

  useEffect(() => {
    setCustomModuleState((prevState) => ({
      ...prevState,
      disableDrag: true,
    }));
  }, []);

  const handleSaveColData = (data) => {
    handleCloseColumn();
    let tableCols = [];
    if (editMode) {
      [contextTableColumn[editedIndex]] = data;

      tableCols = [...contextTableColumn];
      setState((prevState) => ({
        ...prevState,
        editMode: false,
        editedIndex: -1,
      }));
    } else {
      tableCols = [...contextTableColumn, ...data];
    }

    updateTableColumns(tableCols);
  };

  const handleEdit = (index) => {
    if (contextTableColumn?.[index]?.relation?.currLocation?.name === 'Product_Core_Information') {
      contextTableColumn[index].relation.currLocation = {
        label: 'Product Core Information',
        name: 'Product_Core_Information',
        _id: 11,
      };
    }
    setState((prevState) => ({
      ...prevState,
      addEditColumnModal: true,
      editMode: true,
      editedIndex: index,
    }));
  };

  const handleColumnDelete = (delIndex) => {
    setState((prevState) => ({
      ...prevState,
      showConfirmModal: true,
      deletedIndex: delIndex,
    }));
  };

  const toggleConfirm = () => {
    setState((prevState) => ({
      ...prevState,
      showConfirmModal: !showConfirmModal,
      deletedIndex: -1,
    }));
  };

  const confirmDelete = () => {
    toggleConfirm();
    const newArray = [...contextTableColumn];
    newArray.splice(deletedIndex, 1);
    updateTableColumns([...newArray]);
  };

  const moveTr = (dragIndex, hoverIndex) => {
    if (Number.isInteger(dragIndex) && Number.isInteger(hoverIndex)) {
      const updatedSeqList = update(contextTableColumn, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, contextTableColumn[dragIndex]],
        ],
      });

      // Add sequenceId to each object in the updatedSeqList
      const updatedSeqListWithSequenceId = updatedSeqList.map((item, index) => ({
        ...item,
        sequenceId: index,
      }));
      updateTableColumns([...updatedSeqListWithSequenceId]);
    }
  };

  const handleActiveInactive = (index) => {
    const tableCols = tableColumns;
    const column = tableCols[index];

    if (column && 'isActive' in column) {
      column.isActive = !column.isActive;
    } else {
      column.isActive = false;
    }

    updateTableColumns(tableCols);
  };

  const renderTr = (colEle, colIndex) => {
    return (
      <ColumnDragTR
        key={colEle?.id}
        id={colEle?.id}
        handleEdit={handleEdit}
        handleColumnDelete={handleColumnDelete}
        colEle={colEle}
        colIndex={colIndex}
        moveTr={moveTr}
        handleActiveInactive={handleActiveInactive}
      />
    );
  };

  const uploadXlsx = async () => {
    setShowUploadModal(true);
  };

  const closeUploadModal = () => {
    setShowUploadModal(false);
  };

  const handleFileError = (binary) => {
    if (binary.size > 5000000) {
      toasterMsg(t('CUSTOM_MODULE.FILE_ERROR'), 'danger');
      return true;
    }
    return false;
  };

  const handleMaxLimitError = (columnNames) => {
    if (columnNames?.length > maxColLimit) {
      toasterMsg(t('CUSTOM_MODULE.MAX_LIMIT'), 'danger');
      return true;
    }
    return false;
  };

  const createColumnObject = (colName, optionsData) => {
    const columnOptions = optionsData?.map((option) => {
      return { id: uuidv4(), label: option[colName], value: option[colName] };
    });
    return {
      key: 'Dropdown',
      label: 'Dropdown',
      placeholder: t('CUSTOM_LIBRARY.DEPENDENT_SETTING.SELECT_OPTION'),
      isActive: true,
      options: columnOptions,
      fieldName: colName,
    };
  };

  const createRestObject = (colName, tableColumnsToInsert, tableDataArray, columnNames) => {
    const relationArray = [];
    tableDataArray?.forEach((data, dataIndex) => {
      if (tableColumnsToInsert?.[0]?.options?.[dataIndex]?.value === data[columnNames[0]]) {
        relationArray.push({ isContent: tableColumnsToInsert?.[0]?.options?.[dataIndex], to: data?.[colName] || '' });
      }
    });
    return {
      fieldName: colName,
      key: 'Dependent',
      label: 'Dependent',
      isActive: true,
      placeholder: t('CUSTOM_LIBRARY.STATIC_CONTROLS.DEPENDENT_PLACEHOLDER'),
      relation: {
        colourArray: [
          {
            colourValue: '',
            colourType: 'green',
            startPercentage: '',
            endPercentage: '',
          },
          {
            colourValue: '',
            colourType: 'amber',
            startPercentage: '',
            endPercentage: '',
          },
          {
            colourValue: '',
            colourType: 'red',
            startPercentage: '',
            endPercentage: '',
          },
        ],
        dropDownControl: {
          control: tableColumnsToInsert?.[0],
          i: `0_${tableColumnsToInsert?.[0].fieldName}_${labelInModal || 'Table'}`,
        },
        dropDownControlOptions: [],
        fixed: true,
        isContentArr: relationArray,
        isControlOptions: tableColumnsToInsert?.[0]?.options,
        name: '',
      },
    };
  };

  const handleUploadedDocument = async () => {
    const uploadedDoc = await docRef.current.selectedDocument();
    if (!uploadedDoc) {
      toasterMsg(t('CUSTOM_MODULE.FILE_EXTENSION'), 'danger');
      return null;
    }
    return uploadedDoc;
  };

  const handleBinaryFile = async (binary) => {
    if (handleFileError(binary)) return null;
    return await treadFile(binary, true);
  };

  const handleTableColumnsInsertion = (columnNames, optionsData, tableDataArray, tableColumnsToInsert) => {
    columnNames?.forEach((colName, columnIndex) => {
      if (columnIndex === 0) {
        const columnObj = createColumnObject(colName, optionsData);
        tableColumnsToInsert.push(columnObj);
      } else {
        const restObject = createRestObject(colName, tableColumnsToInsert, tableDataArray, columnNames);
        tableColumnsToInsert.push(restObject);
      }
    });
  };

  const handleFile = async () => {
    if (docRef?.current) {
      const uploadedDoc = await handleUploadedDocument();
      if (uploadedDoc) {
        const binary = uploadedDoc.document;
        const convertedXlsxToArray = await handleBinaryFile(binary);
        if (!convertedXlsxToArray) return;
        const columnNames = convertedXlsxToArray?.headerKeys?.filter((e) => e !== '') || [];
        const tableDataArray = convertedXlsxToArray?.data || [];
        const optionsData = convertedXlsxToArray?.data || [];
        if (handleMaxLimitError(columnNames)) return;
        const tableColumnsToInsert = [];
        handleTableColumnsInsertion(columnNames, optionsData, tableDataArray, tableColumnsToInsert);

        updateTableColumns([...contextTableColumn, ...tableColumnsToInsert]);

        closeUploadModal();
      }
    }
  };

  return (
    <>
      <Modal className="common-custom-modal modal-medium-2x" backdrop="static" show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>{t('CUSTOM_MODULE.CREATE_TABLE')}</Modal.Title>
          <div className="d-flex align-items-center ml-auto">
            <p className="m-0 mr-2">{contextTableColumn?.length >= maxColLimit && '(Maximum columns added)'}</p>
            {tableColumns?.length === 0 && (
              <button
                type="button"
                title={t('CUSTOM_MODULE.UPLOAD')}
                onClick={() => uploadXlsx()}
                className="btn d-inline-flex"
                aria-label={t('CUSTOM_MODULE.UPLOAD')}
              >
                <UploadIcon size={24} />
              </button>
            )}
          </div>
          <CloseIcon size={24} className="cursor-pointer" onClick={handleAddColumnInSection} />
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex">
            <NewInput
              type="text"
              className="text-bordered w-300"
              value={labelInModal}
              placeholder={t('CUSTOM_MODULES.LIBRARY.TABLE.TABLE_COLUMN_MODAL.TABLE_TITLE')}
              onChange={(e) => handleTableTitle(e.target.value)}
            />
            <button type="submit" disabled={contextTableColumn?.length >= maxColLimit} onClick={handleColumn} className="btn btn-default ml-auto">
              {t('CUSTOM_MODULE.ADD_COLUMN')}
            </button>
          </div>
          <table className="table common-custom-table mt-16 layout-fixed">
            <thead>
              <tr>
                <th className="w-50px">&nbsp;</th>
                <th className="w-300px">{t('CUSTOM_MODULE.FIELD_NAME')}</th>
                <th className="w-200px">{t('CUSTOM_MODULE.TYPE')}</th>
                <th className="w-100px" />
              </tr>
            </thead>
            <tbody>
              <DndProvider backend={HTML5Backend}>
                {tableColumns?.map((colEle, colIndex) => {
                  return renderTr(colEle, colIndex);
                })}
              </DndProvider>
            </tbody>
          </table>
          <div className="common-model-footer mt-16">
            <button type="submit" aria-label="Save" onClick={handleAddColumnInSection} disabled={contextTableColumn?.length === 0} className="btn p-0">
              <TickIcon size={24} />
            </button>
          </div>
        </Modal.Body>
      </Modal>
      {addEditColumnModal && (
        <AddEditColumnModal
          show={addEditColumnModal}
          handleClose={handleCloseColumn}
          tableColumns={tableColumns}
          tableControls={tableControls}
          saveColumnData={handleSaveColData}
          editMode={editMode}
          editedIndex={editedIndex}
          maxColLimit={maxColLimit}
          i={i}
        />
      )}

      {showConfirmModal && (
        <ConfirmationPopup
          onOpen={showConfirmModal}
          onConfirm={() => confirmDelete()}
          title={t('CUSTOM_MODULE.DELETE_COLUMN')}
          message={t('CUSTOM_MODULE.ARE_YOU_SURE')}
          toggle={() => toggleConfirm()}
        />
      )}
      {showUploadModal && (
        <ImportModal showUploadModal={showUploadModal} closeUploadModal={closeUploadModal} docRef={docRef} addDocument={handleFile} loader={false} />
      )}
    </>
  );
}

export default TableCoumnModal;
